import axios from "axios";
import { currentBrand } from '../../src/configs/brands';


const instance = axios.create({
  baseURL: `https://${currentBrand?.apiBaseUrl}/api/v1/back-office/`,
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "true",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
   if (error.response?.status === 401) {
    localStorage.setItem("sessionExpired", "true");
     localStorage.removeItem("token");

     window.location.replace(`${window.location.origin}/login`);
   }
    if (error.response) {
      return Promise.reject(error.response);
    }
    return Promise.reject({
      message: "Network error or server is unreachable",
    });
  },
);

export default instance;
